import React from "react";
import { connect } from "react-redux";
import { Alert, Button, Card, Table } from "react-bootstrap";
import PropTypes from "prop-types";

import { mine as getMySurveys } from "../../actions/surveys";
import { send as pageInfo, loading } from "../../actions/pages";
import { buildSurveyTokenizeUrl } from "../../utils/survey-link";

export const formatDate = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    return date.toLocaleDateString();
};

export const surveyErrorMessage = (error) => (
    error?.response?.data?.error?.message
    || error?.response?.data?.message
    || error?.message
    || "Unable to load shared surveys."
);

const EmptyState = () => (
    <div className="text-center text-muted py-5">
        No surveys have been shared with you yet.
    </div>
);

const SurveyTable = ({ items }) => (
    <Table responsive hover className="mb-0">
        <thead>
            <tr>
                <th>Name</th>
                <th>Description</th>
                <th style={{ width: "140px" }}>Shared</th>
                <th className="text-end" style={{ width: "120px" }} />
            </tr>
        </thead>
        <tbody>
            {items.map((item) => {
                const openUrl = buildSurveyTokenizeUrl(item);
                return (
                <tr key={item.uuid}>
                    <td>
                        <div className="fw-medium">{item.name}</div>
                    </td>
                    <td className="text-muted">{item.description}</td>
                    <td>{formatDate(item.createdAt)}</td>
                    <td className="text-end">
                        {openUrl ? (
                            <Button
                                size="sm"
                                variant="outline-primary"
                                href={openUrl}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Open
                            </Button>
                        ) : null}
                    </td>
                </tr>
                );
            })}
        </tbody>
    </Table>
);

export class Surveys extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            error: ""
        };
    }

    componentDidMount = async () => {
        await this.loadData();
    };

    loadData = async () => {
        this.props.loading(true);
        this.setState({ error: "" });

        try {
            const result = await this.props.getMySurveys();

            this.setState({
                items: result?.items || []
            });

            await this.props.pageInfo({
                title: "My Surveys",
                breadcrumb: "Surveys",
                description: "Surveys shared with you"
            });
        } catch (error) {
            this.setState({
                error: surveyErrorMessage(error)
            });
        } finally {
            this.props.loading(false);
        }
    };

    render() {
        const { error, items } = this.state;

        return (
            <Card body className="mb-5">
                {error ? (
                    <Alert variant="danger" className="mb-0">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <span>{error}</span>
                            <Button type="button" size="sm" variant="outline-danger" onClick={this.loadData}>
                                Retry
                            </Button>
                        </div>
                    </Alert>
                ) : items.length ? <SurveyTable items={items} /> : <EmptyState />}
            </Card>
        );
    }
}

Surveys.propTypes = {
    getMySurveys: PropTypes.func.isRequired,
    pageInfo: PropTypes.func.isRequired,
    loading: PropTypes.func.isRequired
};

export default connect(null, { getMySurveys, pageInfo, loading })(Surveys);
